// **** import modules ****
import app, { Klass, csl, u_, vuwer } from "@@assets/scripts/common";
import "@pressmedia/vuwcolony";
import onChangeState from "./_onChangeState";
import "./_list";
import "./_article";


// **** process ****
app.gaAutoSendPageview = false;

vuwer.setProp({
	...onChangeState,
	childSections: [],
	onReady($window) {
		this._defaultTitle = document.title;
		this._defaultDescription = this.meta.$description.attr("content");
		
		this.getChildren().forEach(vuw => {
			if( vuw instanceof Klass("Vuw") && (/Section$/).test(vuw.name) ) {
				this.childSections.push( vuw.name.replace(/Section$/, "") );
			}
		});
	},
});

// [body] set prop
vuwer.get("body").setProp({
	onChangeState(state) {
		u_.isString(state.view) && this.$self.attr("data-view", state.view);
	}
});

// [breadcrumbs] set prop
vuwer.get("breadcrumbs").setProp({
	onReady($self) {
		this.defaultLevel = this.getLevel();
		this.contentText = this.getBreads().eq(-1).text();
	},
	
	onChangeState(state) {
		if( state.text && u_.isString(state.text) ) {
			this.upLevel(1).addBread({
				text: this.contentText,
				href: "./"
			}).children("a").addClass("change-state");
			
			this.addBread({
				text: state.text
			});
			
		} else {
			const len = this.getLevel();
			if(len > this.defaultLevel) {
				this.upLevel(len - this.defaultLevel + 1);
				this.addBread({
					text: this.contentText
				});
			}
		}
	}
});


app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
});

app.exec();
